import type { ServiceCode } from '@common/enums';
import type { ServiceSettings } from '../interfaces/serviceSettings';

export function createSettingsToRenderList(
    settingsList: { [key: string]: any },
    currentSettings: ServiceSettings,
    serviceCode: ServiceCode
) {
    const settingsToRender: any[] = [];

    Object.keys(settingsList).forEach((listKey) => {
        if (
            settingsList[listKey].conditionKey &&
            !currentSettings[settingsList[listKey].conditionKey as keyof ServiceSettings]
        ) {
            return;
        }
        if (
            settingsList[listKey].conditionServiceCodes &&
            !settingsList[listKey].conditionServiceCodes.some((code: ServiceCode) => code === serviceCode)
        ) {
            return;
        }

        if (
            'isAnalyst' in currentSettings &&
            currentSettings.isAnalyst! &&
            (listKey === 'isBiometrician' || listKey === 'isGrader')
        ) {
            return;
        }

        settingsToRender.push({ listKey, setting: settingsList[listKey], header: settingsList[listKey].header });
    });

    return settingsToRender;
}
